// The ring of the thought chain's running step (same radius, stroke and signal colour), emptying once over
// `durationMs` instead of spinning: the time left for the offer it sits on. Without motion it stays full.
const RADIUS = 9;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function CountdownRing({ durationMs, className = "" }: { durationMs: number; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={`size-4 -rotate-90 stroke-accent-decoration ${className}`} fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r={RADIUS} stroke="currentColor" strokeOpacity={0.25} strokeWidth={2} />
      <circle
        cx="12"
        cy="12"
        r={RADIUS}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        className="studio-countdown"
        style={{ animationDuration: `${durationMs}ms`, ["--studio-ring" as string]: `${CIRCUMFERENCE}` }}
      />
    </svg>
  );
}
